// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Avmu","label":"styles_label__H6AC9"};